import { differenceInCalendarDays } from 'date-fns/differenceInCalendarDays';
import { endOfDay } from 'date-fns/endOfDay';
import { isToday } from 'date-fns/isToday';
import { startOfDay } from 'date-fns/startOfDay';
import { type DateRange } from 'react-day-picker';
import { toast } from 'sonner';

import { backendApis } from '@/backendApis';
import { electronApis } from '@/features/electron-api';

export const deleteContextBetween = async (startMs: number, endMs?: number) => {
  try {
    await backendApis.inputs.deleteInputs(startMs, endMs);
    await electronApis.context.deleteContext(startMs, endMs);
    toast.success('Context deleted successfully');
  } catch (error) {
    toast.error('Failed to delete context');
    throw error;
  }
};

export const deleteContext = async (milliseconds: number) =>
  deleteContextBetween(Date.now() - milliseconds);

export const getDayRangeBounds = (range: DateRange | undefined) => {
  if (!range?.from) return null;
  const from = range.from;
  const to = range.to ?? range.from;
  return {
    from,
    to,
    startMs: startOfDay(from).getTime(),
    endMs: isToday(to) ? Date.now() : endOfDay(to).getTime(),
    days: differenceInCalendarDays(to, from) + 1,
  };
};
